export default __webpack_public_path__ + "static/media/image38.d6a0052e.png";